import React from "react";
import Layout from "./hoc/Layout/Layout";
import { BrowserRouter as Router } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "quill-emoji/dist/quill-emoji.css";
// import "emoji-picker-react/dist/main.css";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "react-quill/dist/quill.snow.css"; // ES6
import "./override.scss";
import ScrollMemory from "react-router-scroll-memory";
import NetworkDetector from "./hoc/NetworkDetector/NetworkDetector";
import AdhocLayout from "./hoc/Layout/Adhoc/AdhocLayout";
import "./styles/global/new-global.scss";
import { ADHOC_USER_PATH } from "./hoc/Layout/Adhoc/constants/adhocConstant";

function App() {
  const currentPathName = window.location.pathname;
  return (
    <Router>
      <ScrollMemory />
      {ADHOC_USER_PATH.includes(currentPathName) && <AdhocLayout />}
      {!ADHOC_USER_PATH.includes(currentPathName) && <Layout />}
    </Router>
  );
}

export default NetworkDetector(App);
